module.exports = __webpack_public_path__ + "img/ico25.1ed8ac75.jpg";